import React, { useState } from 'react';
import Btn from '../../../../Components/Btn';
import Modal from '../../../../Components/Modal';
import ModalHeader from '../../../../Components/ModalHeader';
import ModalBody from '../../../../Components/ModalBody';
import ModalFooter from '../../../../Components/ModalFooter';
import DemotionList from './DemotionList';
import PromotedList from './PromotedList';
import ReplacementList from './ReplacementList';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';

function getNameOfDimension(dimension) {
	switch (dimension) {
		case promoteId:
			return 'Promoted products';
		case demoteId:
			return 'Demoted products';
		case replaceId:
			return 'Swapped products';
	}
}
import {
	replaceId,
	demoteId,
	promoteId
} from '../../Ranking/utils';

export default function ModalManualSort({
	activeTab,
}) {
	const {
		addPromotedProductManualy,
		addDemotedProductManualy,
		addReplaceProductManualy,
		modalManualSorting,
		setModalManualIsOpen,
		rankingObject,
		previewTenant,
	} = useRankingContext();

	const [newElementToAdd, setNewElementToAdd] = useState('');
	const [modalHeight, setModalHeight] = useState(640);

	function addPromotedProductManualyFunction(el) {
		addPromotedProductManualy(el);
	}
	function addDemotedProductManualyFunction(el) {
		addDemotedProductManualy(el);
	}
	function addReplaceProductTransform(el) {
		addReplaceProductManualy(el);
		setModalManualIsOpen(false);
	}
	const addFunction = () => {
		if (activeTab === promoteId) {
			addPromotedProductManualyFunction(newElementToAdd);
		}
		if (activeTab === demoteId) {
			addDemotedProductManualyFunction(newElementToAdd);
		}
		if (activeTab === replaceId) {
			addReplaceProductTransform(newElementToAdd);
		}
	};

	if (!modalManualSorting) return <></>;

	if (activeTab === replaceId) {
		return (
			<Modal
				isOpen={modalManualSorting}
				width={450}
				height={modalHeight}
				onClose={() =>
					setModalManualIsOpen(false)
				}
			>
				<ReplacementList
					selectedTenant={rankingObject.tenant}
					previewTenant={previewTenant}
					addReplaceManualy={(element) => setNewElementToAdd(element)}
					fromProduct={false}
					setModalHeight={setModalHeight}
				/>
			</Modal>
		);
	}

	return (
		<Modal
			isOpen={modalManualSorting}
			width={500}
			onClose={() =>
				setModalManualIsOpen(false)
			}
		>
			<ModalHeader
				title={getNameOfDimension(activeTab)}
			/>
			<ModalBody>
				{activeTab === promoteId &&
					<PromotedList
						addPromotedProductManualy={(element) => setNewElementToAdd(element)}
					/>
				}
				{activeTab === demoteId &&
					<DemotionList
						addDemotedProductManualy={(element) => setNewElementToAdd(element)}
					/>
				}
			</ModalBody>
			<ModalFooter
				primaryAction={
					<Btn
						onClick={() => addFunction()}
						message="Add"
						color="primary"
					/>
				}
				secondaryAction={
					<Btn
						onClick={() => setModalManualIsOpen(false)}
						message="Cancel"
						color="secondary"
						style="ghost"
					/>
				}
			/>
		</Modal>
	);
}
